import * as React from 'react';
import PropTypes from 'prop-types';

import BookCardCommon from '../cross-platform/classroom/BookCardCommon';
import BookCardElectron from '../cross-platform/classroom/BookCardElectron';

const propTypes = {
  book: PropTypes.object.isRequired,
  classroom: PropTypes.string.isRequired,
  extraMenuOptions: PropTypes.any
};

/** Electron */
let electronVersion = ({ book, classroom, extraMenuOptions }) => {
  return <BookCardElectron book={book} classroom={classroom} extraMenuOptions={extraMenuOptions} />;
};
electronVersion.propTypes = propTypes;

/** Web */
let webVersion = ({ book, classroom }) => {
  return <BookCardCommon book={book} classroom={classroom} />;
};
webVersion.propTypes = propTypes;

/**
 * MAIN
 */
let versions = {
  electron: electronVersion,
  web: webVersion
};

export let BookCard;
export let configure = mode => {
  BookCard = versions[mode];
};
